<script>
import Flow from '@shell/edit/logging-flow';
export default { components: { Flow } };
</script>
<template>
  <Flow v-bind="$attrs" />
</template>
